import moment from "moment";
import { listSortedWeekIndices } from "../resolveProgramWeekExercises";

/**
 * Teams program builder week header (matches ReadOnlyWeekColumn / EditorWeekColumn).
 * @param {Object} [program]
 * @returns {string|undefined}
 */
export function formatTeamsProgramWeekDateLabel(program) {
  if (!program?.startDate) {
    return undefined;
  }
  const start = moment(program.startDate, "YYYYMMDD");
  if (!start.isValid()) {
    return undefined;
  }
  return `${start.format("MMM D")} - ${start
    .clone()
    .add(6, "days")
    .format("MMM D")}`;
}

/**
 * Merge read-only previous-program column + editable program for Program Insights (Teams).
 * Call only when the builder shows `ReadOnlyWeekColumn` (program > 1, edit mode).
 *
 * @param {Object} params
 * @param {Object} [params.previousWeeks]
 * @param {Object} params.weeks
 * @param {Object[]} [params.previousExercises]
 * @param {Object[]} [params.currentExercises]
 * @param {Object} [params.previousProgram]
 * @param {Object} [params.currentProgram]
 * @returns {{ builderWeeks: Object, programExercises: Object[], weekHeaderLabels: Object<number, string> }}
 */
export function buildTeamsProgramInsightsInput({
  previousWeeks,
  weeks,
  previousExercises = [],
  currentExercises = [],
  previousProgram,
  currentProgram,
}) {
  const currentWeeks = weeks ?? {};
  const currentExercisesList = Array.isArray(currentExercises)
    ? currentExercises
    : [];
  const previousWeekSessions = previousWeeks?.["1"];

  if (
    !Array.isArray(previousWeekSessions) ||
    previousWeekSessions.length === 0
  ) {
    return {
      builderWeeks: currentWeeks,
      programExercises: currentExercisesList,
      weekHeaderLabels: {},
    };
  }

  const previousExercisesList = Array.isArray(previousExercises)
    ? previousExercises
    : [];
  const currentIndices = listSortedWeekIndices(currentWeeks);
  const previousLabel = formatTeamsProgramWeekDateLabel(previousProgram);
  const currentLabel = formatTeamsProgramWeekDateLabel(currentProgram);

  /** @type {Object<string, Object[]>} */
  const builderWeeks = { "1": previousWeekSessions };
  /** @type {Object<number, string>} */
  const weekHeaderLabels = {};

  if (previousLabel) {
    weekHeaderLabels[1] = previousLabel;
  }

  for (const weekIndex of currentIndices) {
    builderWeeks[String(weekIndex + 1)] = currentWeeks[String(weekIndex)];
  }

  if (currentLabel) {
    for (const weekIndex of currentIndices) {
      weekHeaderLabels[weekIndex + 1] = currentLabel;
    }
  }

  return {
    builderWeeks,
    programExercises: [...previousExercisesList, ...currentExercisesList],
    weekHeaderLabels,
  };
}
